import { ColumnDef } from '@tanstack/react-table'
import { SurgeryDataMock } from '@type/history.type'
import { Table2 } from '@ui'
import { useMemo } from 'react'
import { patientHistoryTableClassName } from '../Results/tableStyles'

export default function SurgicalHistoryTable({
  isLoading,
  records
}: {
  isLoading?: boolean
  records: SurgeryDataMock[]
}) {
  const columns = useMemo<ColumnDef<SurgeryDataMock>[]>(
    () => [
      {
        accessorKey: 'surgery',
        header: 'Surgery',
        cell: ({ row }) => <span>{row.original.attributes.surgery_type || '-'}</span>
      },
      {
        accessorKey: 'date',
        header: 'Date',
        cell: ({ row }) => <span>{row.original.attributes.surgery_date || '-'}</span>
      },
      {
        accessorKey: 'location',
        header: 'Location',
        cell: ({ row }) => <span>{row.original.attributes.location || '-'}</span>
      }
    ],
    []
  )

  return (
    <Table2
      className={patientHistoryTableClassName}
      columns={columns}
      data={records}
      emptyDescription="No history found."
      isLoading={isLoading}
      message="No history found"
      showPagination={false}
      wrapperClass="overflow-x-auto"
    />
  )
}
